import React, { Component } from 'react';

class StopsMetadata extends Component {
    render() {
        return (
            <div>
                <h2>Página de paragens</h2>
                <p>
                    Nesta página, encontra todas as paragens disponíveis na edição ativa na data selecionada.
                    A página é dividida em paragens na rede ativa e paragens no rascunho.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Criar, editar e eliminar paragens na rede ativa e na de rascunho</li>
                    <li>Exportar as paragens existentes tanto na rede ativa como na de rascunho para um ficheiro CSV</li>
                    <li>Pesquisar as paragens disponíveis na rede ativa e na rede de rascunho</li>
                    <li>Ver as paragens no mapa</li>
                    <li>Comparar as paragens da rede ativa com as paragens da de rascunho</li>
                </ul>
            </div>
        );
    }
}

export default StopsMetadata;
